import React, { Fragment, useEffect, useState, useCallback } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { Trans } from "react-i18next";

import { checkPlaylistLayer, clearPlaylistLayer, fetchPlaylistLayer, updatePlaylistLayer } from "actions/playlist.layer.action";

import { CLEAR, SUCCESS } from "constant/status";
import { JAVASCRIPT_VOID } from "constant/config";

import { LAYER } from "components/boards/post/vod/layer/playlist/PlaylistLayer";
import useInfiniteScroll from "components/hook/useInfiniteScroll";

const ListLayer = ({ vod, onChangeLayer, close }) => {
	const dispatch = useDispatch();

	const [page, setPage] = useState(1);

	// 재생목록 리스트
	const { status = CLEAR, more = true, data = [] } = useSelector(
		({ playlistLayerReducer }) => ({
			status: playlistLayerReducer.status,
			more: playlistLayerReducer.more,
			data: playlistLayerReducer.data,
		}),
		shallowEqual,
	);

	// 페이지 변경
	const handleChangePage = useCallback(() => {
		if ((status === CLEAR || status === SUCCESS) && more) {
			setPage(page + 1);
		}
	}, [more, page, status]);

	// infinite scroll 로 데이터 가져오기
	const scrollContainerRef = useInfiniteScroll(handleChangePage);

	// 초기 데이터 세팅
	useEffect(() => {
		dispatch(fetchPlaylistLayer(page, vod.title_no));
	}, [dispatch, page, vod.title_no]);

	// 레이어 변경 또는 닫기 시 리스트 초기화
	useEffect(
		() => () => {
			console.log("test");
			dispatch(clearPlaylistLayer());
		},
		[dispatch],
	);

	// 재생목록 추가 버튼 클릭 시 재생목록 추가 레이어로 이동
	const handleChangeLayer = useCallback(
		(layer) => () => {
			onChangeLayer(layer);
		},
		[onChangeLayer],
	);

	// 재생목록에 영상 담기 체크
	const handleCheckPlaylistLayer = (idx) => () => {
		dispatch(checkPlaylistLayer(idx));
	};

	// 재생목록에 담은 영상 반영
	const handleUpdatePlaylistLayer = async () => {
		const changedIdxList = data.filter((playlist) => playlist.already !== playlist.checked).map((playlist) => playlist.idx);
		if (changedIdxList.length > 0) {
			await dispatch(updatePlaylistLayer(vod.title_no, changedIdxList));
		}

		close();
	};

	return (
		<Fragment>
			{/* 제목 영역 */}
			{isMobile && <p className="pop-title"><Trans>재생목록에 담기</Trans></p>}
			{!isMobile && (
				<div className="pop-title">
					<h3><Trans>재생목록에 담기</Trans></h3>
				</div>
			)}

			{/* 리스트 노출 영역 */}
			<div className="pop-body">
				{/* 재생목록 리스트 노출 */}
				{data.length > 0 && (
					<ul className="PlayListBox" ref={scrollContainerRef}>
						{data.map((playlist) => (
							<li key={playlist.idx}>
								<input
									type="checkbox"
									value={playlist.idx}
									id={`checked_${playlist.idx}`}
									checked={playlist.checked}
									onChange={handleCheckPlaylistLayer(playlist.idx)}
								/>
								<label htmlFor={`checked_${playlist.idx}`}>{playlist.title}</label>
								{playlist.display !== "N" ? <span><Trans>공개</Trans></span> : <span className="hidden"><Trans>비공개</Trans></span>}
							</li>
						))}
					</ul>
				)}
				{isMobile && data.length === 0 && (<p className="nonList"><Trans>재생목록을 만들어주세요.</Trans></p>)}

				{/* 재생목록 등록 페이지 이동 */}
				<button type="button" className="btn_NewAddList" onClick={handleChangeLayer(LAYER.ADD)}>
					+ <Trans>새 재생목록 만들기</Trans>
				</button>
			</div>

			{/* 버튼 영역 */}
			<div className="pop-btn">
				{isMobile && (
					<Fragment>
						<a href={JAVASCRIPT_VOID} className="btn" onClick={close}>
							<Trans>취소</Trans>
						</a>

						<button type="button" className="btn" onClick={handleUpdatePlaylistLayer}>
							<strong>
								<Trans>확인</Trans>
							</strong>
						</button>
					</Fragment>
				)}
				{!isMobile && (
					<a href={JAVASCRIPT_VOID} className="btn" onClick={handleUpdatePlaylistLayer}>
						<Trans>확인</Trans>
					</a>
				)}
			</div>
		</Fragment>
	);
};

export default ListLayer;
